export const ROOM_OBJECT_TYPES = {
  WALL: "wall",
  OPENING: "opening",
  SERVICE: "service",
};

export const OPENING_TYPES = {
  DOOR: "door",
  WINDOW: "window",
  PASSAGE: "passage",
};

export const SERVICE_TYPES = {
  WATER: "water",
  DRAIN: "drain",
  SOCKET: "socket",
  SWITCH: "switch",
  VENTILATION: "ventilation",
  GAS: "gas",
};

function createId(prefix) {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export function createRoomDefaults() {
  return createThreeWallRoomPreset();
}

export function createWall({
  id,
  name,
  start = { x: 0, z: 0 },
  end = { x: 3000, z: 0 },
  height = 2800,
  thickness = 100,
  inward = "positive_z",
} = {}) {
  return {
    id: id || createId("wall"),
    type: ROOM_OBJECT_TYPES.WALL,
    name: name || "Wall",
    start,
    end,
    height,
    thickness,
    inward,
    locked: false,
  };
}

export function createOpening({
  id,
  wallId,
  type = OPENING_TYPES.WINDOW,
  offset = 1000,
  width = 900,
  height = 1100,
  sillHeight = 900,
  label = "",
} = {}) {
  return {
    id: id || createId("opening"),
    type,
    wallId,
    offset,
    width,
    height,
    sillHeight,
    label,
  };
}

export function createServicePoint({
  id,
  wallId,
  type = SERVICE_TYPES.SOCKET,
  offset = 1000,
  height = 1100,
  label = "",
} = {}) {
  return {
    id: id || createId("service"),
    type,
    wallId,
    offset,
    height,
    label,
  };
}

export function createThreeWallRoomPreset({
  width = 3000,
  depth = 2200,
  height = 2800,
  wallThickness = 100,
  baseFloorOffset = 150,
  wallCabinetOffset = 1500,
  ceilingClearance = 50,
  showFloor = true,
  showCeiling = true,
} = {}) {
  return {
    width,
    depth,
    height,
    floorLevel: 0,
    wallThickness,
    baseFloorOffset,
    wallCabinetOffset,
    ceilingClearance,
    showFloor,
    showCeiling,

    walls: [
      createWall({
        id: "back_wall",
        name: "Back wall",
        start: { x: 0, z: 0 },
        end: { x: width, z: 0 },
        height,
        thickness: wallThickness,
        inward: "positive_z",
      }),

      createWall({
        id: "left_wall",
        name: "Left wall",
        start: { x: 0, z: 0 },
        end: { x: 0, z: depth },
        height,
        thickness: wallThickness,
        inward: "positive_x",
      }),

      createWall({
        id: "right_wall",
        name: "Right wall",
        start: { x: width, z: 0 },
        end: { x: width, z: depth },
        height,
        thickness: wallThickness,
        inward: "negative_x",
      }),
    ],

    openings: [],
    services: [],
  };
}

export function createLRoomPreset({
  mainWallLength = 3000,
  sideWallLength = 2000,
  height = 2800,
  wallThickness = 100,
  baseFloorOffset = 150,
  wallCabinetOffset = 1500,
  ceilingClearance = 50,
} = {}) {
  return {
    width: mainWallLength,
    depth: sideWallLength,
    height,
    floorLevel: 0,
    wallThickness,
    baseFloorOffset,
    wallCabinetOffset,
    ceilingClearance,
    showFloor: true,
    showCeiling: true,

    walls: [
      createWall({
        id: "back_wall",
        name: "Back wall",
        start: { x: 0, z: 0 },
        end: { x: mainWallLength, z: 0 },
        height,
        thickness: wallThickness,
        inward: "positive_z",
      }),

      createWall({
        id: "left_wall",
        name: "Left wall",
        start: { x: 0, z: 0 },
        end: { x: 0, z: sideWallLength },
        height,
        thickness: wallThickness,
        inward: "positive_x",
      }),
    ],

    openings: [],
    services: [],
  };
}